/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LINEAccountLinkURL
 */
export interface LINEAccountLinkURL {
    /**
     * 
     * @type {string}
     * @memberof LINEAccountLinkURL
     */
    url: string;
}

/**
 * Check if a given object implements the LINEAccountLinkURL interface.
 */
export function instanceOfLINEAccountLinkURL(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function LINEAccountLinkURLFromJSON(json: any): LINEAccountLinkURL {
    return LINEAccountLinkURLFromJSONTyped(json, false);
}

export function LINEAccountLinkURLFromJSONTyped(json: any, ignoreDiscriminator: boolean): LINEAccountLinkURL {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function LINEAccountLinkURLToJSON(value?: LINEAccountLinkURL | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

